import HtmlTemplate from "../templating/HtmlTemplate";
import MediaLibrary from "./MediaLibrary";
import {_, _id} from "../util/dom";

export default class EvidenceUploader {

    constructor(service, container) {
        this.service = service;
        this.container = container;
        this.questionId = this.container.dataset.question;
        this.existingFiles = [];

        this.nameList = $(_(".upload-name-list", this.container));
        this.fileTemplate = new HtmlTemplate(_id("media-item-template"));
        this.noMediaTemplate = new HtmlTemplate(_id("no-media-template"));

        this.initExistingFiles();
        $(_(".upload-btn", this.container)).click(evt => this.service.openFileDialog(this));
    }

    initExistingFiles() {
        const keyString = this.container.dataset.keys;

        if(!keyString) {
            return;
        }

        const keys = keyString.split(',');

        this.changeExistingFiles(keys.map(MediaLibrary.get));
    }

    removeFile(key) {
        const fileIndex = this.existingFiles.findIndex(file => file.key === key);
        if(fileIndex < 0) {
            return;
        }

        this.existingFiles.splice(fileIndex, 1);
        const keys = this.existingFiles.map(file => file.key);
        this.service.linkMediaRequest(keys, this.questionId, () =>
            this.changeExistingFiles(this.existingFiles)
        );
    }

    changeExistingFiles(files) {
        this.existingFiles = files;
        this.refreshList();
        this.rebindDelete();
    }

    getNameListHtml() {
        if(!this.existingFiles.length) {
            return this.noMediaTemplate.templateHtml;
        }

        const fileToHtmlInfo = file => [
            file.key,
            this.service.organizationId,
            file.key,
            file.name,
        ];

        return this.fileTemplate.fillMulti(this.existingFiles.map(fileToHtmlInfo));
    }

    refreshList() {
        this.nameList.html(this.getNameListHtml());
    }

    rebindDelete() {
        this.nameList.find('.remove-button').click(evt => {
            const target = evt.currentTarget;
            const fileHtmlElement = target.parentNode;
            const key = fileHtmlElement.dataset.key;
            this.removeFile(key);
        });
    }

};